import React from "react";
import { classes } from "lib/actions/util";

const IconBadge = ({
  size = "8",
  shape,
  className,
  children,
}: {
  size?: "6" | "8";
  shape?: "circle" | "square";
  className?: string;
  children: React.ReactNode;
}) => {
  return (
    <div
      className={classes(
        "flex flex-shrink-0 items-center justify-center rounded-full border shadow",
        size == "6" && "w-6 h-6",
        size == "8" && "w-8 h-8",
        shape === "circle" && "rounded-full",
        shape === "square" && "rounded-md",
        className,
      )}
    >
      {children}
    </div>
  );
};

export default IconBadge;
